/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProteinResponse
 */
export interface ProteinResponse {
    /**
     * 
     * @type {number}
     * @memberof ProteinResponse
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProteinResponse
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ProteinResponse
     */
    codeAscii: string;
    /**
     * 
     * @type {string}
     * @memberof ProteinResponse
     */
    geneName: string;
    /**
     * 
     * @type {string}
     * @memberof ProteinResponse
     */
    uniprot: string;
    /**
     * 
     * @type {string}
     * @memberof ProteinResponse
     */
    proteinName: string;
    /**
     * 
     * @type {string}
     * @memberof ProteinResponse
     */
    _function: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProteinResponse
     */
    catalyticFunction: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProteinResponse
     */
    regulation: string;
    /**
     * 
     * @type {string}
     * @memberof ProteinResponse
     */
    sequence: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProteinResponse
     */
    essentialResiduePositions: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProteinResponse
     */
    domains: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProteinResponse
     */
    structResidues?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProteinResponse
     */
    residuesAvailableForVinaJob?: Array<number>;
}

/**
 * Check if a given object implements the ProteinResponse interface.
 */
export function instanceOfProteinResponse(value: object): value is ProteinResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('codeAscii' in value) || value['codeAscii'] === undefined) return false;
    if (!('geneName' in value) || value['geneName'] === undefined) return false;
    if (!('uniprot' in value) || value['uniprot'] === undefined) return false;
    if (!('proteinName' in value) || value['proteinName'] === undefined) return false;
    if ((!('_function' in value) && !('function' in value)) || (value['_function'] === undefined && value['function'] === undefined)) return false;
    if (!('catalyticFunction' in value) || value['catalyticFunction'] === undefined) return false;
    if (!('regulation' in value) || value['regulation'] === undefined) return false;
    if (!('sequence' in value) || value['sequence'] === undefined) return false;
    if (!('essentialResiduePositions' in value) || value['essentialResiduePositions'] === undefined) return false;
    if (!('domains' in value) || value['domains'] === undefined) return false;
    return true;
}

export function ProteinResponseFromJSON(json: any): ProteinResponse {
    return ProteinResponseFromJSONTyped(json, false);
}

export function ProteinResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProteinResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'codeAscii': json['codeAscii'],
        'geneName': json['geneName'],
        'uniprot': json['uniprot'],
        'proteinName': json['proteinName'],
        '_function': json['function'],
        'catalyticFunction': json['catalyticFunction'],
        'regulation': json['regulation'],
        'sequence': json['sequence'],
        'essentialResiduePositions': json['essentialResiduePositions'],
        'domains': json['domains'],
        'structResidues': json['structResidues'] == null ? undefined : json['structResidues'],
        'residuesAvailableForVinaJob': json['residuesAvailableForVinaJob'] == null ? undefined : json['residuesAvailableForVinaJob'],
    };
}

export function ProteinResponseToJSON(json: any): ProteinResponse {
    return ProteinResponseToJSONTyped(json, false);
}

export function ProteinResponseToJSONTyped(value?: ProteinResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'codeAscii': value['codeAscii'],
        'geneName': value['geneName'],
        'uniprot': value['uniprot'],
        'proteinName': value['proteinName'],
        'function': value['_function'],
        'catalyticFunction': value['catalyticFunction'],
        'regulation': value['regulation'],
        'sequence': value['sequence'],
        'essentialResiduePositions': value['essentialResiduePositions'],
        'domains': value['domains'],
        'structResidues': value['structResidues'],
        'residuesAvailableForVinaJob': value['residuesAvailableForVinaJob'],
    };
}

